import { isSmartTV } from '@/shared/lib'

import { SeriesRowContainerTV } from '@/appTV/Series/SeriesRowContainerTV'
import { SeriesRowContainer } from '@/clients/streamiq/features/Series/SeriesRowContainer'

export const SeriesPage = () => (
    <>{isSmartTV() ? <SeriesRowContainerTV /> : <SeriesRowContainer />}</>
)
